import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.submitting = false
    this.pendingSubmit = false
    this.boundSubmitEnd = this.submitEnd.bind(this)
    this.element.addEventListener("turbo:submit-end", this.boundSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.boundSubmitEnd)
  }

  changed() {
    this.submit()
  }

  submit() {
    if (this.submitting) {
      this.pendingSubmit = true
      return
    }

    this.submitting = true
    this.pendingSubmit = false
    this.element.requestSubmit()
  }

  submitEnd() {
    this.submitting = false

    if (this.pendingSubmit) {
      this.submit()
    }
  }
}
